import { Box, InputAdornment } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldStyled from "../detailed-form/components/TextFieldStyled";
import {
  Input,
  Form,
  Spin
} from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { useDebounce, useLocalStorage } from "../detailed-form/utils/hooks";
import axios from "axios";
import dayjs from "dayjs";
import { GET_API_BASE_URL } from "@/app/utils/functions";

const EmailValidator = ({
  id,
  value = "",
  disabled = false,
  onVerified,
  onChange,
  autoFocus = true,
  shrinkLabel = false,
  hideLabel = false,
  size = "medium",
}) => {
  const [email, setEmail] = useState(value);
  const [lastVerifiedEmail, setLastVerifiedEmail] = useState("");
  const [error, setError] = useState({ hasError: false, message: "" });
  const [validationState, setValidationState] = useState(value ? "success" : null);
  const { addDebounce } = useDebounce();
  const { sessionId } = useLocalStorage();

  useEffect(() => {
    setEmail(value);
  }, [value]);

  const executeValidation = () => {
    const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (email !== "") {
      if (emailRegex.test(email)) {
        email !== lastVerifiedEmail && validateEmail(email);
      } else {
        onVerified(false);
        setError({ hasError: true, message: "Invalid Email" });
        setValidationState("error");
      }
    }
  };

  const handleSubmit = (email) => {
    const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(email)) {
      return addDebounce(async () => {
        await validateEmail(email);
      });
    }
    return addDebounce(async () => {
      return null;
    });
    // setError({ hasError: true, message: "Invalid email" });
  };

  const handleChange = (e) => {
    const { value = "" } = e.target;
    setValidationState(null);
    setEmail(value.trim());
    onChange && onChange(value.trim());
    onVerified(false);
    setError({ hasError: false, message: "" });
    handleSubmit(value);
  };

  // const isValidEmail = (emailToValidate) => {
  //   // Regular expression for validating an email
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  //   // Test the email against the regex
  //   return emailRegex.test(emailToValidate);
  // };

  // const validateEmail = () => {
  //   if (isValidEmail(email)) {
  //     onVerified(email);
  //     setError({ hasError: false, message: "" });
  //   } else {
  //     onVerified(false);
  //     setError({ hasError: true, message: "Email is invalid" });
  //   }
  // };

  const validateEmail = async (email) => {
    // if (!isValidEmail(email)) {
    //   onVerified(false);
    //   setError({ hasError: true, message: "Email is invalid" });
    //   return false;
    // }
    if (email.includes("@fair.inc")) {
      onVerified(email);
      setError({ hasError: false, message: "" });
      setValidationState("success");
      setLastVerifiedEmail(email);
      const ele = document.getElementById(id);
      // ele && ele.focus();
    } else {
      setValidationState("loading");
      const resp = sessionId
        ? dummyResponse(email)
        : await axios.post(
            `${GET_API_BASE_URL()}/verify-email`,
            { email },
            { withCredentials: true }
          );
      const validationResult = resp.data;
      const { responseObject: { Result = "Invalid" } = {} } =
        validationResult || {};
      if (Result === "Valid") {
        onVerified(email);
        setError({ hasError: false, message: "" });
        setValidationState("success");
        setLastVerifiedEmail(email);
      } else {
        onVerified(false);
        setError({ hasError: true, message: "Invalid Email" });
        setValidationState("error");
      }
      const ele = document.getElementById(id);
      console.log({ele});
      // ele && ele.focus();
    }
  };

  return (
    // <Box>
    <Form.Item
      label="Email"
      validateStatus={error.message ? "error" : ""}
      help={error.message}
      hasFeedback
    >
  <Input
    id={id}
    name="email"
    disabled={disabled}
    placeholder="john@domain.com"
    value={email}
    onChange={handleChange}
    onPressEnter={(e) => {
      executeValidation();
    }}
    size={'large'}
    // autoFocus={true}
    suffix={
      validationState !== 'loading' ? (
        error.message ? null : <img
          src="/ssl-secured.png"
          alt="ssl-security"
          style={{ width: 60, borderRadius: '6px' }}
        />
      ): <Spin indicator={<LoadingOutlined spin />} size="small" />
    }
  />
  </Form.Item>
    // <TextFieldStyled
    //     id={id}
    //     fullWidth
    //     variant="outlined"
    //     placeholder="john@domain.com"
    //     label={hideLabel ? null : "Email"}
    //     error={error.hasError}
    //     // helperText={error.message}
    //     value={email}
    //     name="email"
    //     onChange={handleChange}
    //     multiline={true}
    //     maxRows={2}
    //     type="email"
    //     size={size}
    //     sx={{
    //       "& .MuiInputBase-input": {
    //         textTransform: "none",
    //       },
    //     }}
    //     type="email"
    //     state={state}
    //     autoFocus={autoFocus}
    //     InputLabelProps={{
    //       shrink: shrinkLabel,
    //     }}
    //     showInputProgress={true}
    //     onEnterPressed={(e) => {
    //       executeValidation();
    //     }}
    //     InputProps={{
    //       endAdornment: !state && (
    //         <InputAdornment position="end">
    //           <img
    //             src="/ssl-secured.png"
    //             alt="ssl-security image"
    //             style={{ width: 60, borderRadius: "6px" }}
    //           />
    //         </InputAdornment>
    //       ),
    //     }}
    //   />
    // </Box>
  );
};

export default EmailValidator;

const dummyResponse = (email) => {
  const formattedDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
  const resp = {
    success: true,
    message: "Verification Proceeded",
    responseObject: {
      address: email,
      Result: "Valid",
      sub_status: "",
      free_email: false,
      did_you_mean: null,
      account: "mailme",
      domain: "gmail.com",
      domain_age_days: "3122",
      smtp_provider: "g-suite",
      mx_found: "true",
      mx_record: "gmail-smtp-in.l.google.com",
      firstname: null,
      lastname: null,
      gender: null,
      country: null,
      region: null,
      city: null,
      zipcode: null,
      processed_at: formattedDateTime,
    },
    statusCode: 200,
  };
  return { data: resp };
};
